import { useContext, useState } from "react";
import {
	AccessControlNames,
	GeneralNames,
	ScheduleNames,
  LoadingInfoNames
} from "../../../namesConstants/names";
import { Column } from "primereact/column";
import { InputSwitch } from "primereact/inputswitch";
import { headerClassName } from "../../../assets/customStyles";
import { CustomPaginatorTable } from "../../../components/Table/CustomPaginatorTable";
import { CustomAlertDialog } from "../../../components/Dialogs/CustomAlertDialog";
import { StoreContext } from "../../../business/Provider";
import { useCurrentCompany } from "../../../hooks/useCurrentCompany";
import { SYSTEM_NAME_ID } from "../../../shared/constants/externalSystems";
import { FullLoading } from '../../../components/FullLoading';
import useCompanySetting from '../../../hooks/company/useCompanySetting';

const VACACIONES_ACCESS_NAME = "Vacaciones";
const validateVacationFlag =
	(window.REACT_APP_VACATIONACCESS_FLAG === true ||
		window.REACT_APP_VACATIONACCESS_FLAG === "true") ??
	false;
const bodyClassName = "!border-r-2 !border-b-0 !border-secondary-PCS004 !text-black !justify-start";

export const TableAccess = ({ list, filters, setAccessValue }) => {
	const { getAccessRoleState } = useContext(StoreContext);

	const [sort, setSort] = useState([{ field: "name", order: 1 }]);
	const [pendingVacacionesAccess, setPendingVacacionesAccess] = useState(null);
	const company = useCurrentCompany();
	const isNominas = company?.externalTypeId === SYSTEM_NAME_ID.NOMINAS;
	const [conversionLoading, setConversionLoading] = useState(false);
	const { syncIncidentTypesAsAbsenceTypes } = useCompanySetting();

	const isVacacionesGrantedForAnyRole = () => {
		let output = list.some((r) => {
			const vacaciones = r.accesses.find(
				(a) => a.accessName === VACACIONES_ACCESS_NAME,
			);
			return vacaciones !== undefined && vacaciones.grant !== false;
		});
		return output;
	};

  const verifyIncidentTypesSync = async (deepCopy, accessName, row) => {
    if (accessName === VACACIONES_ACCESS_NAME && row.roleName === "Propietario" && deepCopy.grant === true) {
      setConversionLoading(true);

      try {
        await syncIncidentTypesAsAbsenceTypes();
      } finally {
        setConversionLoading(false);
      }
    }
  }

	const actionSwitch = (row, accessName) => {
		const result = row.accesses.find((a) => a.accessName === accessName);
		let valueChecked = result?.grant !== false;
		const { isOwner } = getAccessRoleState.accessRole.data.data;
		let organigrama = null;

		let valueDisabled = false;

		if (row.roleName === "Colaborador") {
			if (accessName === "Invitaciones" || accessName === "Organigrama") {
				valueDisabled = true;
				valueChecked = false;
			}
		} else if (
			row.roleName === "Propietario" ||
			row.roleName === "Administrador" ||
			row.roleName === "Nominista"
		) {
			if (accessName === "Asistencia") {
				// buscamos el access de Organigrama porque tenemos que setearlo tambien
				let tmp = row.accesses.find((a) => a.accessName === "Organigrama");
				organigrama = JSON.parse(JSON.stringify(tmp.access));
			}

			if (accessName === VACACIONES_ACCESS_NAME && !validateVacationFlag) {
				valueDisabled = true;
			}

			if (accessName === "CFDI" || accessName === "Perfil") {
				valueDisabled = true;
				valueChecked = false;
			} else {
				if (accessName == "Organigrama") {
					valueDisabled = true;
					const asistencia = row.accesses.find(
						(a) => a.accessName === "Asistencia",
					);
					valueChecked = asistencia?.grant !== false;
				}
			}
		}

		if (row.roleName == "Propietario") {
			if (!isOwner) {
				valueDisabled = true;
			}
		}

		// --
		const deepCopy = JSON.parse(JSON.stringify(result.access));
		deepCopy.grant = !valueChecked;
		return (
			<InputSwitch
				checked={valueChecked}
				disabled={valueDisabled}
				onChange={() => {
					let vacacionesGrantedForAnyRole = isVacacionesGrantedForAnyRole();
					if (
						accessName === VACACIONES_ACCESS_NAME &&
						deepCopy.grant === true &&
						isNominas &&
						!vacacionesGrantedForAnyRole
					) {
						setPendingVacacionesAccess({ access: deepCopy, row });
						return;
					}
          
          verifyIncidentTypesSync(deepCopy, accessName, row);

					setAccessValue(deepCopy);
					if (organigrama != null) {
						organigrama.grant = deepCopy.grant;
						setAccessValue(organigrama);
					}
				}}
			/>
		);
	};

	return (
		<div className="flex w-full h-full relative">
			<FullLoading
				loadingState={conversionLoading}
				message={LoadingInfoNames.SyncIncidentTypesLoading}
			/>

			<CustomPaginatorTable
				value={list}
				sortField="roleName"
				filters={filters}
				responsiveLayout="scroll"
				globalFilterFields={["roleName"]}
				emptyMessage={GeneralNames.GeneralEmptyMessage}
				currentPageReportTemplate={ScheduleNames.CurrentPageReportTemplate}
				resizableColumns
				columnResizeMode="fit"
				usePagination={false}
				style={{ height: "100%", width: "100%" }}
				setSort={setSort}
				sort={sort}
			>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 4, flexBasis: "100px" }}
					field="roleName"
					header={"Rol"}
					bodyClassName={bodyClassName}
				/>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 4, flexBasis: "100px" }}
					header={"Invitaciones"}
					body={(rowData) => actionSwitch(rowData, "Invitaciones")}
					bodyClassName={bodyClassName}
				/>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 4, flexBasis: "100px" }}
					header={"Solicitudes"}
					body={(rowData) => actionSwitch(rowData, "Solicitudes")}
					bodyClassName={bodyClassName}
				/>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 4, flexBasis: "100px" }}
					header={"Asistencia"}
					body={(rowData) => actionSwitch(rowData, "Asistencia")}
					bodyClassName={bodyClassName}
				/>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 4, flexBasis: "100px" }}
					header={"Organigrama"}
					body={(rowData) => actionSwitch(rowData, "Organigrama")}
					bodyClassName={bodyClassName}
				/>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 4, flexBasis: "100px" }}
					header={"Vacaciones y Permisos"}
					body={(rowData) => actionSwitch(rowData, "Vacaciones")}
					bodyClassName={bodyClassName}
				/>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 4, flexBasis: "100px" }}
					header={"CFDI"}
					body={(rowData) => actionSwitch(rowData, "CFDI")}
					bodyClassName={bodyClassName}
				/>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 4, flexBasis: "100px" }}
					header={"Perfil"}
					body={(rowData) => actionSwitch(rowData, "Perfil")}
					bodyClassName={bodyClassName}
				/>
			</CustomPaginatorTable>
			<CustomAlertDialog
				open={pendingVacacionesAccess !== null}
				setOpen={(value) => {
					if (!value) setPendingVacacionesAccess(null);
				}}
				title={AccessControlNames.VacacionesConfirmTitle}
				message={AccessControlNames.VacacionesConfirmMessage}
				agreeLabel={AccessControlNames.VacacionesConfirmContinue}
				onCancelFunction={() => setPendingVacacionesAccess(null)}
				onConfirmFunction={async () => {
					const { access, row } = pendingVacacionesAccess;
					await verifyIncidentTypesSync(access, VACACIONES_ACCESS_NAME, row);
					setAccessValue(access);
					setPendingVacacionesAccess(null);
				}}
				style={{ width: "32rem" }}
			/>
		</div>
	);
};
